import { object, string, array } from 'zod'
import type { BannerMoodProps } from 'src/components/department/types/banner-mood'

export function useBannerMood() {
  function validateProps(props: BannerMoodProps) {
    try {
      const bannerProps = object({
        sessionTitle: string(),
        categories: array(
          object({
            linkURL: string(),
            Texto: string(),
            image: object({
              mobile: string(),
              tablet: string(),
              desktop: string(),
            }),
          })
        ),
      })

      bannerProps.parse(props)

      return true
    } catch {
      console.warn('Invalid banner mood data')

      return false
    }
  }

  return {
    validateProps,
  }
}
